export default __webpack_public_path__ + "static/media/map-pin-red.52fe7b82.svg";